import { render, staticRenderFns } from "./LenderReview.vue?vue&type=template&id=3823349d&scoped=true&"
import script from "./LenderReview.vue?vue&type=script&lang=js&"
export * from "./LenderReview.vue?vue&type=script&lang=js&"
import style0 from "./LenderReview.vue?vue&type=style&index=0&id=3823349d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823349d",
  null
  
)

export default component.exports